import Keyb from "keyb"
import Pointer from "poin"
import Joyp from "joyp"

import Sequence from "@frog/source/models/Sequence.js"
import Stage from "@frog/source/models/Stage.js"
import Unit from "@frog/source/models/Unit.js"
import Selection from "@frog/source/models/Selection.js"
import Zone from "@frog/source/models/Zone.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Geometry from "@frog/source/utility/Geometry.js"
import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/admin/Dev.js"
import InkDialogue from "@frog/source/utility/integration/InkDialogue.js"
import getLevelStatus from "@frog/source/models/logic/getLevelStatus.js"
import Random from "@frog/source/utility/Random.js"
import games from "@frog/source/data/games/index.js"

import {nanoid} from "nanoid"
import seedrandom from "seedrandom"
import querystring from "query-string"

export default class Chapter {
    static load(proto, options) {
        options = options || {}

        const chapter = new Chapter()
        chapter.type = "combat"
        chapter.player = proto.player || {"affiliation": "good"}
        chapter.slug = proto.chapter.slug
        chapter.gameslug = proto.gameslug
        chapter.images = proto.chapter.images
        chapter.audio = proto.chapter.audio
        chapter.hasTutorial = proto.chapter.hasTutorial
        chapter.hasPreparePhase = proto.chapter.hasPreparePhase
        chapter.hasUndoEndTurnButtons = proto.chapter.hasUndoEndTurnButtons
        chapter.isRandomized = proto.chapter.isRandomized

        chapter.decorations = proto.chapter.decorations || {}

        if(chapter.audio != undefined) {
            if(chapter.audio instanceof Array != true) {
                Audiomix.trigger(chapter.audio)
            } else {
                chapter.audio.forEach((audio) => {
                    Audiomix.trigger(audio)
                })
            }
        }

        chapter.encounters = proto.chapter.encounters

        if(options.isBlockingSideEffects != true) {
            const query = querystring.parse(window.location.search)
            const seed = query.seed || proto.randomSeed || nanoid()
            Random.setSeed(seed)
        }
        chapter.animationSequence = options.animationSequence

        // chapter.events = proto.chapter.events
        chapter.stage = Stage.load({
            "stage": proto.chapter.stage,
            "player": proto.player,
            "chapterParty": proto.chapterParty,
            "hasPreparePhase": chapter.hasPreparePhase,
            "startingEncounter": proto.chapter.startingEncounter,
            "chapterSlug": chapter.slug,
            "gameSlug": chapter.gameslug,
        })
        if(proto.chapter.stage != undefined
        && options.isBlockingSideEffects != true) {
            Dev.loadedProtostage = proto.chapter.stage
            Object.values(Dev.loadedProtostage.units).forEach((unit) => {
                Dev.cacheUnitReferredProperties({unit, "player": chapter.player, "chapterSlug": chapter.slug, "gameSlug":  chapter.gameslug})
            })
        }
        // let that = chapter
        // for(let key in that) {
        //     this[key] = that[key]
        // }

        chapter.previousStages = []

        if(options.isBlockingSideEffects != true) {
            this.sequence = {
                "steps": []
                // .concat(Stage.getEventSteps(chapter.stage, "turn:0:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every:start"))
                // .concat(Stage.getEventSteps(chapter.stage, "turn:every-even:start"))
            }
            if(this.sequence.steps != undefined
            && this.sequence.steps.length > 0) {
                chapter.stage = this.sequence.steps[chapter.sequence.steps.length - 1].omegastage
            }
        }

        if(chapter.hasPreparePhase == true) {
            chapter.startPreparePhase()
        } else {
            chapter.startPlayPhase()
        }

        chapter.selection = new Selection({"chapter": chapter})

        return chapter
    }
    get sequence() {
        if(this.animationSequence != undefined) return this.animationSequence
        return App.sequence
    }
    set sequence(sequence) {
        if(this.animationSequence != undefined) {
            this.animationSequence = sequence
        } else {
            App.sequence = sequence
        }
    }
    startPreparePhase() {
        this.phase = "prepare"
    }
    startPlayPhase({dialogue} = {}) {
        this.phase = "play"

        let steps = []
            .concat(Stage.getEventSteps(this.stage, "chapter:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:0:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every:start"))
            .concat(Stage.getEventSteps(this.stage, "turn:every-even:start"))

        if(steps.length > 0) {
            this.stage = steps.filter((step) => step.name != "SavestateCapture").pop()?.omegastage
            this.sequence = {"steps": steps}
        }

        Stage.calculateActions(this.stage)
    }
    update(delta) {
        this.selection.update(delta)

        if(Dev.inProtoMode == false) {
            if(Keyb.wasJustPressed("Z")
            || Joyp.wasJustPressed(0, "left-bumper", delta.ms)
            || Joyp.wasJustPressed(0, "right-bumper", delta.ms)) {
                Dev.actionTrace.push({"type": "undoAction"})
                Dev.recordSavestate("livePlaytest")
                this.undoAction()
            }
        }

        if(Keyb.isPressed("<control>") && Keyb.isPressed("R")) {
            App.game.chapter.restart()
        }
    }
    setStage(stage) {
        this.previousStages.push(this.stage)
        if(this.previousStages.length > 10) {
            this.previousStages.shift()
        }

        this.stage = stage
    }
    clearPreviousStages() {
        this.previousStages = []
    }
    reloadStage(options) {
        options = options || {}
        let protogame = games[this.gameslug]
        let protochapter = protogame.chapters[this.slug]
        this.stage = Stage.load({
            "stage": protochapter.stage,
            "player": options.player || protogame.player,
            "chapterParty": protogame.chapterParty,
            "hasPreparePhase": protochapter.hasPreparePhase,
            "startingEncounter": this.stage.currentEncounterKey
        })
        this.recalculateStage()
        Dev.actionTrace = []
    }
    replaySavestateFromActiontrace(savestate, options) {
        options = options || {}

        for (const savedSelection of savestate.actionTrace) {
            if(savedSelection.type == "endTurn") {
                this.endPlayerTurn(this.stage, {"isReplayingActionTrace": true})
                continue
            }
            if(savedSelection.type == "undoAction") {
                this.undoAction()
                continue
            }
            if(savedSelection.type == "killAllEnemies") {
                this.killAllEnemies()
                continue
            }

            const unit = this.stage.units[savedSelection.performerKey]
            if(unit == undefined) {
                console.error("Terminating savestate replay. This saved action's performer no longer exists: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                break
            }
            unit.actionmap = Unit.calculateActions(unit.key, this.stage)
            const actionlist = unit.actionmap[savedSelection.position.x + "x" + savedSelection.position.y]
            if(actionlist == undefined) {
                console.error("Terminating savestate replay. This saved action's position no longer has any actions: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                this.selection.selectedUnitKey = savedSelection.performerKey
                break
            }
            const subactionlist = this.selection.findSubactionsInActionlist({unit, actionlist, "options": {}})
            const indexedAction = subactionlist.filter((action) => {
                return action.type == savedSelection.type
                    && action.skillKey == savedSelection.skillKey
                    && action.omegastage.units[action.performerKey].position.x == savedSelection.performerPosition.x
                    && action.omegastage.units[action.performerKey].position.y == savedSelection.performerPosition.y
            })[0]
            if(indexedAction == undefined) {
                console.error("Terminating savestate replay. This saved action no longer available: ", savedSelection)
                this.selection.hoveredAction = savedSelection
                this.selection.selectedUnitKey = savedSelection.performerKey
                break
            }

            if(options.isShowingEveryStep == true) {
                this.sequence = {"steps": (this.sequence.steps || {}).concat(indexedAction.steps)}
            } else {
                this.sequence = {"steps": indexedAction.steps}
            }
            this.setStage(indexedAction.omegastage)
        }
        if(options.isShowingEveryStep == true) {
            return
        }
        if(savestate.sequenceLengthRemaining == undefined) {
            this.sequence = undefined
        } else {
            const newLength = savestate.sequenceLengthRemaining
            if(this.sequence == undefined) {
                console.error("Savestate replay error: Replay has no animated sequence to show")
                return
            }
            if(this.sequence.steps.length < newLength) {
                console.error("Savestate replay error: Replay's animation sequence length does not match")
                return
            }
            this.sequence.steps = this.sequence.steps.slice(this.sequence.steps.length - newLength, this.sequence.steps.length)
        }
    }
    killAllEnemies() {
        this.saveStage()
        let currentZone = this.stage.encounters[this.stage.currentEncounterKey]
        const alliedUnits = Object.values(this.stage.units).filter((unit) => {
            return Zone.isInBounds(currentZone, unit.position)
                && unit.affiliation == this.stage.player.affiliation
        })
        Object.values(this.stage.units).map((unit) => {
            if(Zone.isInBounds(currentZone, unit.position)) {
                if(unit.affiliation != this.stage.player.affiliation
                && unit.affiliation != "none") {
                    unit.health = 0
                    unit.isDead = true
                    const EXPERIENCE_PER_KILL = 20
                    alliedUnits[0].experience += EXPERIENCE_PER_KILL
                    alliedUnits.unshift(alliedUnits.pop())
                }
            }
        })
        this.recalculateStage()
    }
    undoAction() {
        if(this.previousStages.length > 0) {
            this.stage = this.previousStages.pop()

            // If we are also recording the
            // actions for a test snapshot, then
            // make sure we undo here as well.
            // TODO: read the protoactions from
            // our previousStages list?
            if(window.frog != undefined
            && window.frog.test != undefined
            && window.frog.test.snapshot != undefined) {
                window.frog.test.snapshot.protoactions.pop()

                // TODO: What happens if we undo before
                // the snapshot.alphastage? All following
                // protoactions wouldn't make any sense.
            }

            Audiomix.trigger("UndoAction")
            // if(this.selection.canSelect(this.selection.selectedUnitKey, this.stage) == false) {
            //     this.selection.reset()
            // }
            this.selection.reset()

            this.sequence = undefined
        }
    }
    performAction(action) {
        // if(window.frog != undefined
        // && window.frog.test != undefined
        // && window.frog.test.snapshot != undefined) {
        //     window.frog.test.snapshot.protoactions.push({
        //         "unitKey": action.performerKey,
        //         "position": Geometry.copy(action.position),
        //         "actionKey": action.key,
        //     })
        // }

        this.sequence = {"steps": action.steps}
        // action.omegastage.steps = steps
        Stage.calculateActions(action.omegastage)
        this.setStage(action.omegastage)

        // Auto-finishing
        if(this.hasAutoEnd === true
        || this.hasUndoEndTurnButtons === false) {
            const hasFinishedTurn = Object.values(action.omegastage.units).filter((unit) => {
                if(unit.affiliation != App.game.chapter.stage.player.affiliation) return false
                if(unit.isDead == true) return false
                if(unit.hasBeenRemoved == true) return false
                if(Zone.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounterKey].zone, unit.position)) return false
                if(unit.subclasses != undefined) {
                    return unit.energy[1] != false
                        || unit.energy[2] != false
                } else {
                    return unit.energy[1] != false
                }

            }).length == 0
            if(hasFinishedTurn == true) {
                return this.endPlayerTurn(action.omegastage)
            }
        }

        return action.omegastage
    }
    saveStage() {
        const omegastage = Stage.copy(this.stage)
        omegastage.steps = []
        this.setStage(omegastage)
    }
    recalculateStage() {
        Stage.calculateActions(this.stage, {"force": true})
    }
    endPlayerTurn(stage, options) {
        stage = stage || this.stage
        options = options || {}

        Audiomix.trigger("EndTurn")

        // if(stage.turn.affiliation != this.player.affiliation) {
        //     return console.error("not currently player turn.")
        // }

        this.selection.reset()

        // And now.. perform the next turn!!

        if(stage.nextTurn == undefined) {
            Stage.calculateNextTurn(stage)
        }

        options.isReplayingActionTrace = options.isReplayingActionTrace || false
        if(options.isReplayingActionTrace == false) {
            Dev.actionTrace.push({"type": "endTurn"})
            Dev.recordSavestate("livePlaytest")
        }

        const steps = stage.nextTurn.steps
        this.sequence = {"steps": steps}
        if(options.isReplayingActionTrace == false) {
            steps.forEach((step) => {
                if(step.name == "SavestateCapture") {
                    Dev.recordSavestate(step.savestateSlug, step.data)
                }
            })
        }


        const omegastage = steps[steps.length - 1].omegastage
        omegastage.steps = steps
        Stage.calculateActions(omegastage || this.stage)
        this.setStage(omegastage)
        this.clearPreviousStages()

        return omegastage
    }
    restart(options) {
        options = options || {}
        Dev.actionTrace = []
        App.load({
            "game": {
                "slug": this.gameslug,
                "player": options.player || App.game.player,
                "chapter": games[this.gameslug].chapters[App.game.chapter.slug],
                "configuration": games[this.gameslug].configuration,
                "randomSeed": options.randomSeed,
            }
        })
    }
}
